<template>
  <li class="flex justify-between mb-6">
    <div class="flex">
      <div class="w-20 mr-4" v-if="post">
        <img
          :src="`http://umwlcms.test/api/assets/uploads/${post.post_featured_image}`"
          class=" inset-0  w-full object-cover"
          alt="Few Facts About Streaming and Music Creation"
        />
      </div>
      <div class="flex-1">
        <h4 class="post-title text-base mb-2">
          <a
            href="https://stein.rifki.net/stein/2019/04/29/few-facts-about-streaming-and-music-creation/"
            rel="bookmark"
            >{{ post.post_title }}</a
          >
        </h4>
        <div class="post-meta post-meta-bottom text-sm">
          <time class="post-meta-date" datetime="2019-04-29T17:03:15+00:00">{{
            post.post_created_at
          }}</time>
        </div>
      </div>
    </div>
    <div class="actions">
      <ul>
        <li><i class="fa fa-user"></i>Edit</li>
        <li><i class="fa fa-user"></i>Remove</li>
      </ul>
    </div>
  </li>
</template>

<script>
export default {
  name: "PostItem",
  props: ["post"],
  created() {
    console.log("test");
  },
};
</script>

<style lang="scss" scoped></style>
